import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Transaction {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async getCount(countQuery) {
        const res = await this.base.get('/api/transactions/count', countQuery);
        const result = res.data;
        return result;
    }
    async newestFirst(newestFirstQuery) {
        const params = {
            count: newestFirstQuery.count,
            offset: newestFirstQuery.offset,
            limit: newestFirstQuery.limit,
            senderId: newestFirstQuery.senderId,
            senderPublicKey: newestFirstQuery.senderPublicKey,
        };
        const res = await this.base.get('/api/transactions/newestFirst', params);
        const result = res.data;
        return result;
    }
    async getTransactions(query) {
        const params = {
            limit: query.limit,
            offset: query.offset,
            id: query.id,
            senderId: query.senderId,
            senderPublicKey: query.senderPublicKey,
            blockId: query.blockId,
            type: query.type,
            height: query.height,
            message: query.message,
        };
        const res = await this.base.get('/api/transactions/', params);
        const result = res.data;
        return result;
    }
    async getUnconfirmedTransaction(id) {
        const params = {
            id: id,
        };
        const res = await this.base.get('/api/transactions/unconfirmed/get', params);
        const result = res.data;
        return result;
    }
    async getUnconfirmedTransactions(senderPublicKey, address) {
        const params = {
            senderPublicKey: senderPublicKey,
            address: address,
        };
        const res = await this.base.get('/api/transactions/unconfirmed', params);
        const result = res.data;
        return result;
    }
    async addTransactions(transactions) {
        const params = {
            transactions: transactions,
        };
        const res = await this.base.put('/api/transactions/batch', params);
        const result = res.data;
        return result;
    }
    async getConfirmations(id) {
        const params = {
            id,
        };
        const res = await this.base.get('/api/transactions/confirmations', params);
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=transaction.js.map